import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Caller } from '../../_models/caller';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';
import { AccessSecurity } from '../../_models/accessSecurity';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('pwd', { static: false }) pwd: ElementRef;
  userEmail: string = "";
  mail: string = "";
  userPwd: string = "";
  errorMessage: string = "";
  errorEmail: string = "";
  statusText1: string;
  statusText2: string;
  showPassword: boolean = false;

  constructor(private alertService: AlertService, public http: HttpClient
    , private router: Router
    , public caller: Caller
    , public user: User, public g: Globals, public accessSec: AccessSecurity) {
    this.g.accessLeftMenu = "register";
  }

  ngOnInit() {

    window.onbeforeunload = function () { window.history.forward(); };
  }



  validateEmail() {
    this.errorEmail = "";
    /*           if(this.userEmail === 'admin@shift.com'){
              this.showPassword=true;
                setTimeout(()=>{
                    this.pwd.nativeElement.focus();
                  },0);
              return;
              } */
    this.g.loaderDisplay = "display";
    this.userEmail = this.userEmail.trim();
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.userEmail + "&userType=" +"USER" ,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.showPassword = false;
          this.errorEmail = "Couldn't find your shift account";
        } else {
          if (data['code'] == 400 && data['message'] == "Email Id Already Exists.") {
            this.errorEmail = '';
            this.showPassword = true;
            setTimeout(() => {
              this.pwd.nativeElement.focus();
            }, 0);
          } else {
            this.showPassword = false;
            this.errorEmail = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.showPassword = false;
          this.errorEmail = "Please enter valid Email";
        }
      )
  }

  typeEmail() {
    this.statusText1 = "";
    if (this.userEmail === null || this.userEmail === undefined || this.userEmail == '' || this.userEmail === 'undefined') {
      this.errorEmail = '';
      this.statusText1 = ' Please enter Email';
    }
  }


  typePassword() {
    this.statusText2 = "";
    if (this.userPwd == null || this.userPwd === undefined || this.userPwd === '' || this.userPwd === 'undefined') {
      this.statusText2 = 'Please enter Password';
    }
  }

  displayPassword() {
    this.typeEmail();
    if (this.statusText1 !== '') {
      return;
    }
    this.validateEmail();
  }

  submitLogin() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.errorMessage = "";
    if (this.userEmail === null || this.userEmail === undefined || this.userEmail == '' || this.userEmail === 'undefined') {
      this.statusText1 = ' Please enter Email';
    }
    if (this.userPwd == null || this.userPwd === undefined || this.userPwd === '' || this.userPwd === 'undefined') {
      this.statusText2 = 'Please enter Password';
    }
    if (this.statusText1 != "" || this.statusText2 != "") {
      return false;
    }
    this.userEmail = this.userEmail.trim();
    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/login', {
      "password": this.userPwd,
      "rememberMe": true,
      //"username": this.mail
      "username": this.userEmail
    }, {
      headers: header1
    }).subscribe(data => {
      this.g.loaderDisplay = "";

      if (data['code'] == '200') {
        //this.alertService.success('Login','Done successfully');
        //this.mail = "";
        this.user.role = data['role'];
        this.user.accountOwnerId = data['accountOwnerId'];
        this.user.mobileNumber = data['mobileNumber'];
        this.user.sellerId = data['sellerId'];
        this.user.userId = data['userId'];
        this.user.organizationId = data['organizationId'];
        this.user.driverId = data['driverId'];
        this.user.userName = data['userName'];
        this.user.orgUserId = data['orgUserId'];
        this.user.duration = data['duration'];
        this.user.logoURl = data['logoURl'];
        this.user.loadedSampleData = data['loadedSampleData'];
        this.caller.parent = "TWO_VERIFICATION";

        if (data['role'] == 'ROLE_ADMIN') {
          this.user.adminUserId = data['userId'];
          localStorage.setItem('jwt', data['idToken']);
        } else if (data['role'] == 'ACCOUNT_OWNER') {
          localStorage.setItem('jwt', data['idToken']);
          this.g.profilePopup = data['postRegData'];
        } else if (data['role'] == 'DEMO_ACCOUNT') {
          localStorage.setItem('jwt', data['idToken']);
          this.g.profilePopup = data['postRegData'];
        } else if (data['role'] == 'DRIVER') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (data['role'] == 'ROLE_USER') {
          localStorage.setItem('jwt', data['idToken']);
          this.assignSecurityValues(data['securityConfigs'], data['role']);
        } else if (data['role'] == 'WORK_MEN' || data['role'] == 'PACKER') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (data['role'] == 'RECEIVER' || data['role'] == 'SECURITY') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (data['role'] == 'SALES_MKTG' || data['role'] == 'CUSTOMER_CARE') {
          localStorage.setItem('jwt', data['idToken']);
        } else {
          localStorage.setItem('jwt', data['idToken']);
          //this.assignSecurityValues(data['securityConfigs'], data['role']);
        }
        this.router.navigate(['/access/otp']);
      } else {
        if (data['code'] == 404) {
          this.alertService.error('Error', data['message']);
        }
        // this.mail = "";
      }
      this.g.loaderDisplay = "";
      //this.mail = "";
    },
      (err) => {
        this.g.loaderDisplay = "";
        //this.mail = "";
        this.alertService.error('Error', err);
      }
    )
  }

  resetAccessSecurity() {
    for (let key of Object.keys(this.accessSec)) {
      this.accessSec[key] = false;
    }
  }

  assignSecurityValues(securityValues, role) {
    this.resetAccessSecurity();
    let securityConfigs = [];
    securityConfigs = securityValues;
    for (let sc of securityConfigs) {
      //Dashboard
      if (sc.securityCode == "view-dashboard") {
        this.accessSec.viewDashboard = true;
      }

      // outbound orders
      if (sc.securityCode == "create-order") {
        this.accessSec.createOrder = true;
      }
      if (sc.securityCode == "edit-order") {
        this.accessSec.editOrder = true;
      }
      if (sc.securityCode == "view-orders") {
        this.accessSec.viewOrders = true;
      }

      //Inventory
      if (sc.securityCode == "add-product") {
        this.accessSec.addProduct = true;
      }
      if (sc.securityCode == "edit-product") {
        this.accessSec.editProduct = true;
      }
      if (sc.securityCode == "delete-product") {
        this.accessSec.deleteProduct = true;
      }
      if (sc.securityCode == "view-products") {
        this.accessSec.viewProducts = true;
      }

      //workOrders
      if (sc.securityCode == "create-work-order") {
        this.accessSec.createWorkOrder = true;
      }
      if (sc.securityCode == "edit-work-order") {
        this.accessSec.editWorkOrder = true;
      }
      if (sc.securityCode == "view-work-orders") {
        this.accessSec.viewWorkOrders = true;
      }

      // inbound orders
      if (sc.securityCode == "create-inbound-order") {
        this.accessSec.createInboundOrder = true;
      }
      if (sc.securityCode == "edit-inbound-order") {
        this.accessSec.editInboundOrder = true;
      }
      if (sc.securityCode == "view-inbound-orders") {
        this.accessSec.viewInboundOrders = true;
      }
      if (sc.securityCode == "stock-transfer") {
        this.accessSec.stockTransfer = true;
      }

      //addressBook
      if (sc.securityCode == "create-customer") {
        this.accessSec.createCustomer = true;
      }
      if (sc.securityCode == "edit-customer") {
        this.accessSec.editCustomer = true;
      }
      if (sc.securityCode == "view-customers") {
        this.accessSec.viewCustomers = true;
      }

      //invoices
      if (sc.securityCode == "view-invoices") {
        this.accessSec.viewInvoices = true;
      }

      //reports
      if (sc.securityCode == "view-reports") {
        this.accessSec.viewReports = true;
      }

      //my account
      if (sc.securityCode == "view-settings") {
        this.accessSec.viewSettings = true;
      }
      if (sc.securityCode == "edit-settings") {
        this.accessSec.editSettings = true;
      }

      //settings
      if (sc.securityCode == "payment") {
        this.accessSec.payment = true;
      }
      if (sc.securityCode == "shipping-preferences") {
        this.accessSec.shippingPreferences = true;
      }
      if (sc.securityCode == "label-preferences") {
        this.accessSec.labelPreferences = true;
      }
      if (sc.securityCode == "return-preferences") {
        this.accessSec.returnPreferences = true;
      }
    }
  }

  submitLogin2() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.errorMessage = "";
    if (this.userEmail === null || this.userEmail === undefined || this.userEmail == '' || this.userEmail === 'undefined') {
      this.statusText1 = ' Please enter Email';
    }
    if (this.userPwd == null || this.userPwd === undefined || this.userPwd === '' || this.userPwd === 'undefined') {
      this.statusText2 = 'Please enter Password';
    }
    if (this.statusText1 != "" || this.statusText2 != "") {
      return false;
    }
    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/webLogin', {
      "password": this.userPwd,
      "rememberMe": true,
      "username": this.userEmail
    }, {
      headers: header1
    }).subscribe(data => {
      this.g.loaderDisplay = "";

      if (data['code'] == '200') {
        this.caller.parent = "TWO_VERIFICATION";
        this.user.mobileNumber = data['mobileNumber'];
        this.router.navigate(['/access/validatewebotp/' + this.user.mobileNumber]);
      } else {
        if (data['code'] == 404) {
          this.alertService.error('Error', data['message']);
        }
      }
      this.g.loaderDisplay = "";
    },
      (err) => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      }
    )
  }

}

